import * as Mtype from './mutations-type.js'

export default {
  [Mtype.SELECTSOURCE] (state, data) {
    state.selectedSource = data
  },
  // 设置logo的位置
  [Mtype.SET_LOGO_POSITION] (state, data) {
    state.LogoMessage = data
  },
  // 获取设备信息
  [Mtype.GET_FACILITY_MESSAGE] (state, data) {
    state.WSGetFacility = data
  }
}
